<template>
       <div>
           <div
                   class="dropdown"
                   v-click-outside="hideHandler"
                   :class="dropdownClasses"
           >
               <div class="field d-flex align-center justify-space-between" @click="toggleHandler">
                   <div v-if="!currentItem" class="field__input dropdown__not-choosen">{{placeholder}}</div>
                   <div v-else class="field__input">{{currentItem}}</div>
                   <svg-icon name="dropdown" :class="['dropdown__icon', [isOpen ? 'dropdown__icon-active' : '']]"/>
               </div>

               <transition name="dropdown" mode="in-out">
                   <div class="dropdown__list" v-if="isOpen && isDisabled">
                       <div
                               v-for="item in list"
                               :key="item"
                               class="dropdown__list-item"
                               @click="chooseHandler(item)"
                       >
                           {{item}}
                       </div>
                   </div>
               </transition>

               <!--<Validation v-if="v && v.$dirty" :v="v"/>-->


           </div>

<!--           <v-autocomplete-->
<!--               v-model="model"-->
<!--               :items="list"-->
<!--           />-->
       </div>


</template>

<script>
    import ClickOutside from 'vue-click-outside';
     // import Validation from "./Validation";

    export default {
        components: {
             // Validation
        },

        data() {
            return {
                isOpen: false,
                currentItem: null,
                model: "",
            }
        },

        watch: {
            list() {
                if (this.isNeedWatch) {
                    this.currentItem = this.list[0];
                }
            }
        },

        computed: {
            isDisabled() {
                return this.list.length
            },
            dropdownClasses() {
                let classes = [];
                if(this.isLight) {
                    classes.push('is-light');
                }
                if(this.v && this.v.$error) {
                    classes.push('is-error');
                }
                if(!this.isDisabled) {
                    classes.push('dropdown-disabled');
                }
                return classes;
            }
        },

        props: {
            placeholder: {
                type: String,
                required: true,
            },
            list: {
                type: Array,
                required: true,
            },
            v: {
                type: Object,
                required: false,
            },
            isNeedWatch: {
                type: Boolean,
                required: false,
                default: false,
            },
            isLight: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        methods: {
            toggleHandler() {
                if (this.isDisabled) this.isOpen = !this.isOpen;
            },

            hideHandler() {
                this.isOpen = false;
            },

            chooseHandler(item) {
                this.currentItem = item;
                this.$emit('update', item);
                if (this.v) this.v.$touch();
                this.hideHandler();
            }
        },

        directives: {
            ClickOutside
        }
    }
</script>

<style lang="sass" scoped>
.dropdown
    width: 100%
    cursor: pointer
    z-index: 1
    position: relative
    &::v-deep
        .errors
            bottom: auto
            top: 110%

    &-disabled
        cursor: not-allowed

    &__not-choosen
        opacity: 0.4

    &__icon
        margin-right: 4px
        transform: rotate(-180deg)
        transition: transform ease .3s
        cursor: pointer
        width: 12px
        height: 6px
        fill: none
        stroke: #99A8B8

        &-active
            transform: rotate(0deg)
            stroke: #6D7B93

    &__list
        max-height: 195px
        overflow-y: scroll
        position: absolute
        width: 100%
        margin-top: 8px
        border: 1px solid rgba($color--dark, 0.15)
        background: $color--white
        border-radius: 2px
        transform-origin: top
        transition: transform .3s ease-in-out
        z-index: 100

        &::-webkit-scrollbar
            width: 5px
            height: 2px

        &::-webkit-scrollbar-button
            width: 0
            height: 0
        &::-webkit-scrollbar-thumb
            background: $color--blue
            border: none
            border-radius: 50px

        &::-webkit-scrollbar-track
            background: #ffffff
            border: none
            border-radius: 50px

        &::-webkit-scrollbar-corner
            background: transparent


        &-item
            height: 39px
            padding: 6px 12px
            +reg
            font-size: $font-size--s
            color: $color--dark
            cursor: pointer

            &:hover
                color: $color--blue

            &:first-child
                padding-top: 12px

            &:last-child
                padding-bottom: 12px

    &.is-error
        .field
            border-color: rgba(255, 116, 116, 0.5)
            color: rgba(255, 116, 116, 0.5)
            &:hover
                background: transparent

    &.is-light
        .field
            background: $color--dark
            border-color: rgba(#ffffff, 0.2)
            &__input
                color: $color--white
            &__list
                border-color: rgba(#ffffff, 0.2)
                background: #0B234B
        &-item
            color: $color--white
        &::placeholder
            color: white
        &:hover
            .field
                background: #122A50
                border-color: rgba(255, 255, 255, 0.3)
        &.is-error
            .field
                background: #1D294E
                border-color: rgba(255, 116, 116, 0.5)
                color: rgba(255, 116, 116, 0.5)



.dropdown-enter-active,
.dropdown-leave-active
    transition: all 0.3s ease

.dropdown-enter,
.dropdown-leave-active
    opacity: 0
    will-change: opacity
    transform: translateY(-25px)

</style>